import React, { Component } from "react";
import { connect } from "react-redux";
import { agendaAdd } from "../../actions/earlyVotingActions";
import produce from "immer";
import Loading from "../Loading";

const INIT = {
  candidate: "",
  updateToggle: false
};

class Agenda extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INIT };
  }

  componentDidUpdate(prevProps, prevState) {
    const { cCode } = this.props.location.params || {};
    const { cCode: prevC } = prevProps.location.params || {};
    // const { agenda } = this.props.earlyVoting[cCode] || {};

    if (prevC !== cCode) {
      /** STATE RESET, WHEN CLASS CODE IS CHANGING */
      this.setState(
        produce(draft => {
          draft = INIT;
          return draft;
        })
      );
    }
  }

  handleToggle = (agenda, candidate) => {
    this.setState(
      produce(draft => {
        draft.updateToggle = !draft.updateToggle;
        draft.candidate = "";
        if (agenda && candidate !== agenda) {
          draft.candidate = agenda;
        }
      })
    );
  };

  handleChange = e => {
    e.preventDefault();
    const { value } = e.target;
    this.setState(
      produce(draft => {
        draft.candidate = value;
      })
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const { cCode } = this.props.location.params || {};
    const { candidate } = this.state;
    this.props.agendaAdd(cCode, candidate);
    this.setState(
      produce(draft => {
        draft = INIT;
        return draft;
      })
    );
  };

  getAgenda = () => {
    const { cCode } = this.props.location.params || {};
    const { agenda } = this.props.earlyVoting[cCode] || {};
    return agenda;
  };

  updateAgenda = agenda => {
    const { updateToggle, candidate } = this.state;
    return (
      <div className="row d-flex align-items-center mb-3">
        <div className="col-2">안건 {agenda ? "수정" : "추가"}하기</div>
        <div className="col-10" style={{ height: 50 }}>
          {updateToggle ? (
            <form onSubmit={this.handleSubmit} className="row">
              {/* TEXT INPUT */}
              <div className="col-8">
                <input
                  className="w-100"
                  type="text"
                  value={candidate}
                  name="candidate"
                  onChange={this.handleChange}
                />
              </div>
              {/* CONFIRM BUTTON */}
              <div className="col-2 d-flex justify-content-between align-items-center my-1">
                <button
                  type="submit"
                  className={`d-block w-100 btn btn-outline-primary btn-block btn-sm`}
                  style={{ height: "100%" }}
                  disabled={candidate === agenda}
                >
                  완료
                </button>
              </div>
              {/* CANCEL BUTTON */}
              <div className="col-2 d-flex justify-content-between align-items-center my-1">
                <button
                  type="submit"
                  className={`d-block w-100 btn btn-outline-danger btn-block btn-sm`}
                  style={{ height: "100%" }}
                  onClick={() =>
                    this.setState(
                      produce(draft => {
                        draft = INIT;
                        return draft;
                      })
                    )
                  }
                >
                  취소
                </button>
              </div>
            </form>
          ) : (
            <div className="d-flex align-items-center h-100">
              <div
                className="btn btn-outline-primary btn-sm"
                onClick={() => this.handleToggle(agenda, candidate)}
              >
                +
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const { dbSync } = this.props.earlyVoting || {};
    return dbSync ? (
      <>
        {/* VIEW CURRENT AGENDA */}
        <div className="row mt-3">
          <div className="col-2">
            <b>현재 안건</b>
          </div>
          <div className="col-8">{this.getAgenda() || "없음"}</div>
        </div>

        {/* ADD NEW || EDIT AGENDA */}
        {this.updateAgenda(this.getAgenda())}
      </>
    ) : (
      <Loading />
    );
  }
}

const mapStateToProps = state => ({
  earlyVoting: state.earlyVoting,
  location: state.location
});

export default connect(
  mapStateToProps,
  { agendaAdd }
)(Agenda);
